import React from 'react';
import { Link } from 'react-router-dom';
import { SiteNatureRiskViews } from 'src/routes/routesConfig';
import useAppNavigation from 'src/shared/hooks/useAppNavigation';
import { ChevronRight } from 'lucide-react';
import TruncatedText from 'src/shared/components/ui/TruncatedText';

type SiteCellProps = {
    name: string;
    countryName: string | null;
    siteId?: string;
    customerId?: string;
};

const SiteCell = ({ name, countryName, siteId, customerId }: SiteCellProps) => {
    const { getPath } = useAppNavigation();

    const href = siteId && customerId ? getPath(SiteNatureRiskViews.OVERVIEW, { siteId, customerId }) : undefined;

    return (
        <div className='flex flex-col gap-0.5 text-sm min-w-0' data-testid='site-cell'>
            {href ? (
                <Link to={href} className='flex items-center gap-2 flex-1 min-w-0'>
                    <TruncatedText text={name} className='text-black text-sm' />
                    <ChevronRight size={20} className='shrink-0' />
                </Link>
            ) : (
                <TruncatedText text={name} className='text-black text-sm' />
            )}
            {countryName && <TruncatedText text={countryName} className='text-muted-foreground text-xs' data-testid='site-cell-country' />}
        </div>
    );
};

export default SiteCell;
